export default __webpack_public_path__ + "static/media/glider2.faa897d8.png";